<template lang="pug">
v-flex   
  v-card
    v-card-title Proveedores
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar proveedor' single-line hide-details)
      v-dialog(v-model='Suppliers.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12 )
                  v-text-field(v-model='data.name' label='Razón social')
                v-flex(xs12 )
                  v-text-field(v-model='data.address' label='Dirección')
                v-autocomplete(label='Tipo de documento' v-model='data.documentType' :items='documentTypesRecord' :item-text='item=>item.description' :item-value='item=>item.number')
                
                v-flex(xs12 )
                  v-text-field(v-model='data.document' label='Número')
                v-flex(xs12  )
                  v-text-field(v-model='data.phone' label='Telefono')
                v-flex(xs12  )
                  v-text-field(v-model='data.email' label='E-mail')
          v-card-actions
            v-spacer
            v-btn(color='blue darken-1' @click='save()') {{ titleButton }} 
    v-data-table.elevation-1(:headers='headers' :items='workersRecord' :search='search')
      template(v-slot:item.action='{item}')
   
          v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search:'',
    headers: [
      {
        text: 'Razón social',
        align: 'left',
        value: 'name'
      },
      { text: 'Direccion', value: 'address' },
      { text: 'RUC', value: 'document' },
      { text: 'Telefono', value: 'phone' },
      { text: 'E-mail', value: 'email' },
      { text: 'Fecha de creación', value: 'createdAt' },
      { text: '', value: 'action', sortable: false }
    ],
    record: [],
    }),
    methods: {
      ...mapActions({
        editItem: 'Suppliers/get',
        deleteItem: 'Suppliers/clean',
        save: 'Suppliers/add',
        clearForm: 'Suppliers/clearForm',
      }),
    },
    computed: {
      title() { return this.Suppliers.selectedKey == '' ? 'Registar' : 'Crear' },
      titleButton() { return this.Suppliers.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        workersRecord: 'Suppliers/record',
        documentTypesRecord: 'DocumentTypes/record'
      }),
      ...mapState({
        data: state=> state.Suppliers.data,
        Suppliers: state=> state.Suppliers,
      })
    },
  }
</script>
